// register component(s) with react habitat
import withLazyUnveil from '@src/scripts/hoc/withLazyUnveil';

export default {
	SknrwApplicationForm: withLazyUnveil( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "SknrwApplicationForm" */
				'./index'
			),
		height: 845,
		mobileHeight: 863,
	} ),
};
